import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import _get from 'lodash/get';
import _throttle from 'lodash/throttle';
import clsx from 'clsx';
import { SaveGlyph } from 'reaxl-molecules';
import { useBrand } from '@atc/brand';
import { jsx as _jsx } from "react/jsx-runtime";
function InventoryListingSaveGlyph(_ref) {
  let {
    listing = {},
    onSaveToggle = () => {},
    isSaved = false,
    uiContext = 'default',
    className,
    ...rest
  } = _ref;
  const primary = _get(listing, ['images', 'primary'], 0);
  const image = _get(listing, `images.sources[${primary}]`, {});
  const throttledClick = useCallback(function () {
    return _throttle((event, savedData, _isSaved) => {
      onSaveToggle(event, savedData, _isSaved);
    }, 500, {
      trailing: false
    })(...arguments);
  }, [onSaveToggle]);
  const {
    brand
  } = useBrand();
  return /*#__PURE__*/_jsx(SaveGlyph, {
    onClick: event => {
      event.preventDefault(); // prevent scrolling down if triggered by space
      event.stopPropagation();
      const savedData = {
        ...listing
      };
      if (image.src && image['data-flickity-lazyload']) {
        savedData.images.sources[primary] = {
          ...image,
          src: image['data-flickity-lazyload']
        };
      }
      throttledClick(event, savedData, isSaved);
    },
    uiContext: uiContext,
    isSaved: isSaved,
    brand: brand,
    className: clsx('text-size-600 cursor-pointer', className),
    ...rest
  });
}
export default InventoryListingSaveGlyph;